import {MPInsertData} from "../../marketing-purchase/models/m-p-insert-data";
import {OnDropdownFilteredEventArgs} from "../../slick-grid/models/on-dropdown-filtered-event-args";
import {FiltersUnList} from "../../stocks/models/filters-un-list";
import {SlickGridComponent} from "../../slick-grid/slick-grid.component";
import {OnGroupingEventArgs} from "../../slick-grid/models/on-grouping-event-args";
import {Aggregation, AggregationSelector} from "../../stocks/models/aggregation-selector";
import {ColumnSelector} from "../../stocks/models/column-selector";
import {EventArgs} from "../../slick-grid/models/event-args";
import {MainHelper} from "./main-helper";
import {TranslateService} from "@ngx-translate/core";
import * as moment from 'moment';
import {ColumnSettingsBase, WebTableSettings} from "../../slick-grid/models/column-settings-base";
import {ElementRef, Renderer2} from "@angular/core";
import {ISlickGridColumn} from "../../slick-grid/interfaces/slick-grid-column";
import {SlickFilterItem} from "../../slick-grid/models/slick-filter-item";
import {ColumnsGenerator} from "../../slick-grid/models/columns-generator";
import {UniversalListSettings} from "./universal-list";


export class StocksToolbarHelper {
    constructor( public translateService: TranslateService,
        public dataView: Slick.Data.DataView<any>, public columns: Slick.Column<any>[], public grid: SlickGridComponent,
        public columnSettings: ColumnSettingsBase[],
                 public headerRef: ElementRef, public elementRef: ElementRef, private renderer: Renderer2,
                 public toolBarName: string
    ) {
        this.settings = {};
        this.helper = new MainHelper();
        let translate: string[] = ['Undefined', 'GroupingBy', 'ByValue', 'Rows'];
        this.columnSettings.forEach(item =>{
            translate.push(item.translateKey);
            this.settings[this.helper.lowerCaseFirstLetter(item.columnName)] = item;
        });
        this.translateService.get(translate).subscribe(t => this.translates = t);
        try{
            this.toolbarState = JSON.parse(localStorage[this.toolBarName]) || { toolbarHidden: false, fixedToolbar: true };
        } catch (e){
            this.toolbarState = { toolbarHidden: false, fixedToolbar: true };
        }

        this.fixedToolbar = this.toolbarState.fixedToolbar;
        this.toolbarHidden = this.toolbarState.toolbarHidden;

        this.selectedAggregation = null;

        this.universalSettings = new UniversalListSettings('MP', 'filters-list');

        this.universalSettings.showTitle = false;
        this.universalSettings.changeSizes = true;
        this.universalSettings.showSelectedList = true;
        this.universalSettings.selectAllField = 'name';
        this.universalSettings.denyFilters = true;
        this.universalSettings.openSelectedList = true;

        let unGenerator = new ColumnsGenerator<SlickFilterItem>(this.translateService, this.renderer,  this.elementRef),
            unColSettings = [
                new ColumnSettingsBase(1, 'name', 'search-string', null, 'Name', 'string', 1, 150, 10)
            ]
        unGenerator.columnsGenerate([], unColSettings, true).then(r => this.filterColumns = r);



        this.slickFilters = [];
        this.gridFilters = [];
        this.aggregations = [];
        this.grouping = [];
        this.groups = [];
        this.setGrouping = true;
        this.helper.wait(() => {
            this.clearAllMain('filters');
            this.clearAllMain('grouping');
            this.clearAllMain('aggregations')
        });
        this.dataWorkZone = true;
        //console.log(this.columns, 'this.columns')
        // this.columns.forEach(item => {
        //     item.grouping.grouped = false;
        //     item.grouping.aggregated = false;
        //     item.grouping.aggregation ? item.grouping.aggregation.data = new Aggregation(false, false, false, false): null;
        //
        // })

    }

    private helper: MainHelper;
    public dataWorkZone: boolean;
    public setGrouping: boolean;
    public resizeGrid: boolean;
    public showAddAggregation: boolean;
    public showAddGrouping: boolean;
    public workingWithToolbar: boolean;
    public removeSlickFilters: boolean;
    public updateColumns: boolean;
    public _toolbarHidden: boolean;
    public fixedToolbar: boolean;
    public showAggregationSMList: boolean;
    public translates: { [key: string]: string };
    public settings: {[key: string]: ColumnSettingsBase};
    public toolbarState: {toolbarHidden: boolean, fixedToolbar: boolean};
    public selectedAggregation: AggregationSelector;
    public filterColumns: ISlickGridColumn<any>[];
    public universalSettings: UniversalListSettings;
    public gridFilters: OnDropdownFilteredEventArgs<any>[];
    public slickFilters: FiltersUnList[];
    public grouping: Slick.Data.GroupingOptions<any>[];
    public groups: ColumnSelector[];
    public aggregations: AggregationSelector[];

    public set toolbarHidden(val: boolean){
        if (this._toolbarHidden !== val){
            this._toolbarHidden = val;
            this.saveToolbarState();
            this.resizeGrid = true;
            if (!val){
                // this.popper.destroy();
                // this.popper = null;
            }
        }
    }

    public get toolbarHidden(): boolean{
        return this._toolbarHidden;
    }

    //# viewGrid event when filtered, updates summary, set active cell, update sellstyles
    public onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<any>>): void =>{
        this.gridFilters = this.grid.filterHelper.filters;
        this.slickFilters = this.gridFilters.map((item, i) => new FiltersUnList(i, true, item.column.id, item.column.name));
        this.dataWorkZone = true;
    };

    //# add or remove viewGrid Grouping from grouping list
    public updateGroupingEvent = (args: EventArgs<OnGroupingEventArgs<any>>): void =>{
        this.updateGrouping(args.data.command, [new ColumnSelector(args.data.column.id, args.data.column.name, false)]);
        this.dataWorkZone = true;
    };

    //# add or remove viewGrid Grouping
    public updateGrouping = (command: string, columnSel: ColumnSelector[]): void =>{
        switch (command){
            case 'add':
                this.addGrouping(columnSel);
                break;
            case 'remove':
                this.removeGrouping(columnSel);
                break;
        }

        this.generateGrouping();
        this.updateColumnButtonsGrp(this.groups);

        this.joinAggAndGrp();

        this.setGrouping = true;
        //this.dataViews.setGrouping(this.grouping);
        this.resizeGrid = true;

        //this.updateGroupingList();

    };

    //# remove grouping from viewGrid
    private removeGrouping = (columnId: ColumnSelector[]) =>{
        let idx: number[] = [];
        columnId.forEach(item =>{
            this.groups.forEach((inItem, i, arr) =>{
                if (inItem.id === item.id){
                    idx.push(i);
                }
            });
        });
        idx.reverse();
        idx.forEach(item => this.groups.splice(item, 1));
        if (!this.groups.length && this.dataView.getItems().length){
            this.grid.setActiveCell(0, 0);
            //this.onGridClick();
        }
    };

    //# remove all grouping from viewGrid
    public remAllGrouping = (): void =>{
        //let currentPreset = this.helper.getCurrentPreset(this.presets, this.activePresetGuidName);
        this.updateGrouping('remove', this.groups)

    };
    //# add grouping from viewGrid
    private addGrouping = (columnId: ColumnSelector[]): void =>{
        columnId.forEach(item =>{
            this.groups.push(item);
        });
    };

    //# generate array of grouping objects for viewGrid
    private generateGrouping = (): void =>{
        this.grouping = [];
        this.groups.forEach(item =>{
            let grouping = {
                getter: item.id,
                name: item.name,
                formatter: (g) =>{
                    let value: string = '';
                    if (g.value === null || g.value === ''){
                        value = this.translates.Undefined;
                    } else if (this.settings[item.id].type === 'date'){
                        value = moment.utc(g.value).format('L');
                    } else if (this.settings[item.id].type === 'time'){
                        value = moment.utc(g.value).format('DD.MM.YYYY HH:mm:ss');
                    } else{
                        value = g.value;
                    }

                    return `${this.translates.GroupingBy}: ${item.name}, ${this.translates.ByValue}: ${value} <span style='color:green'>(${this.translates.Rows} - ${g.count})</span>`;//"selected:  " + g.value + "  <span style='color:green'>(" + g.count + " items)</span>";
                },
                collapsed: true,
                aggregateCollapsed: true
            };
            this.grouping.push(grouping);
        });
    };

    //# update aggregation or grouping from list
    public getSelectedList = (evt: { type: string, data: ColumnSelector[] | AggregationSelector[] }): void =>{
        // this.showAddAggregation = this.showAddGrouping = false;

        evt ?
            evt.type === 'grouping' ?
                this.applyGrouping(evt.data as ColumnSelector[]) :
                this.applyAggregation(evt.data as AggregationSelector[]) :
            this.showAddAggregation = this.showAddGrouping = false;
        if (evt && evt.data.length){
            this.dataWorkZone = true;
        }
        this.workingWithToolbar = false;
    };

    //# remove filters list
    public applyFiltersList = (event: {data: FiltersUnList[], selected: FiltersUnList[]}): void => {
        if (event){
            let removed = event.data.filter(item => !item.selected).map(item => item.columnId)
            this.remFewCurrentFilter(removed);
            this.slickFilters = event.selected;
        } else{

        }
        this.workingWithToolbar = false;
        this.removeSlickFilters = false;
    }

    //# apply list of columns for grouping from selected grouping list
    public applyGrouping = (data: ColumnSelector[]): void =>{
        this.showAddGrouping = false;
        if (data){

            this.updateColumnButtonsGrp(data);
            this.grouping = [];
            this.groups = [];
            let selected = data.filter(item => item.selected);

            if (selected.length){
                this.addGrouping(selected);
            }
            this.generateGrouping();
            this.joinAggAndGrp();
            this.setGrouping = true;
            //this.dataViews.setGrouping(this.grouping);
            this.resizeGrid = true;

            //this.groupingList = data;
        } else{
            //this.updateGroupingList()
        }
    };

    //# generate list of added aggregation buttons
    private updateColumnButtonsGrp = (data: ColumnSelector[]): void =>{

        this.columns.forEach(item =>{
            item.grouping.grouped = false;
            if (!data.length){
                item.grouping.aggregated = false;
                item.grouping.disableAggr = true;
                item.grouping.aggregation = new AggregationSelector(item.id, item.name, new Aggregation(false, false, false, false));
                this.aggregations.length = 0;
            } else {
                item.grouping.disableAggr = false;
            }
            data.forEach(inItem =>{
                if (item.id === inItem.id){
                    item.grouping.grouped = true;
                }
            });
        });

        this.updateColumns = true;

        // this.grid.setColumns(this.columnsViews);
    };

    //# apply list of columns for aggregation from selected aggregation list
    public applyAggregation = (data: AggregationSelector[]): void =>{
        this.showAddAggregation = false;
        this.aggregations = data;
        this.updateColumnButtonsAgr(data);
        this.joinAggAndGrp();
        this.setGrouping = true;
        //this.dataViews.setGrouping(this.grouping);
        this.resizeGrid = true;
    };

    // add or remove viewGrid Grouping from grouping list
    public updateAggregationEvent = (args: EventArgs<OnGroupingEventArgs<any>>): void =>{
        this.updateAggregation(args.data.command, args.data.aggregation);
        this.dataWorkZone = true;
    };

    //# add, update or remove aggregations
    public updateAggregation = (command: string, aggregations: AggregationSelector[]): void =>{
        switch (command){
            case 'add':
                this.addAggregation(aggregations);
                break;
            case 'remove':
                this.removeAggregation(aggregations);
                break;
            case 'update':
                this.updateAggregationIn(aggregations);
                break;
            case 'cancel':
                return;
        }

        this.joinAggAndGrp();
        this.updateColumns = true;

        //this.grid.setColumns(this.columnsViews);
        this.setGrouping = true;
        //this.dataViews.setGrouping(this.grouping);
        this.resizeGrid = true;
    };

    //# add aggregation for view grid
    private addAggregation = (agg: AggregationSelector[]): void =>{
        agg.forEach(item =>{
            let absent: boolean = false;
            this.aggregations.forEach((inItem, i, arr) =>{
                if (item.id === inItem.id){
                    absent = true;
                    arr[i] = item;
                }
            });

            if (!absent){
                this.aggregations.push(item)
            }
        });
        this.updateColumnButtonsAgr(this.aggregations);

    };

    //# remove aggregation for view grid
    private removeAggregation = (agg: AggregationSelector[]) =>{
        let idx: number[] = [];
        agg.forEach(item =>{
            this.aggregations.forEach((inItem, i, arr) =>{
                if (inItem.id === item.id){
                    idx.push(i)
                }
            });

            this.columns.forEach((inItem, i, arr) =>{
                if (inItem.id === item.id){
                    arr[i].grouping.aggregated = false;
                    arr[i].grouping.aggregation = new AggregationSelector(inItem.id, inItem.name, new Aggregation(false, false, false, false))
                }
            });
        });
        idx.reverse();
        idx.forEach(item => this.aggregations.splice(item, 1));
    };

    //# remove all aggregations for view grid
    public remAllAggregations = (): void =>{
        //let currentPreset = this.helper.getCurrentPreset(this.presets, this.activePresetGuidName);
        this.updateAggregation('remove', this.aggregations)

    };

    //# update aggregations for view grid from list
    private updateAggregationIn = (agg: AggregationSelector[]): void =>{
        agg.forEach(item =>{
            this.aggregations.forEach((inItem, i, arr) =>{
                if (item.id === inItem.id){
                    if (!this.helper.hasSelectedAg(item)){
                        arr.splice(i, 1)
                    } else{
                        arr[i] = item;
                    }
                    this.updateColumnButtonsAgr([item]);
                }
            });
        });
    };

    //# generate aggregation buttons buttons
    private updateColumnButtonsAgr = (data: AggregationSelector[]): void =>{

        this.columns.forEach(item =>{
            item.grouping.aggregated = false;
            item.grouping.aggregation = new AggregationSelector(item.id, item.name, new Aggregation(false, false, false, false));
            data.forEach(inItem =>{
                if (item.id === inItem.id){
                    item.grouping.aggregated = this.helper.hasSelectedAg(inItem);
                    item.grouping.aggregation = inItem;
                }
            });
        });
        this.updateColumns = true;
        //this.updatePresetAfterView = true;
        //this.grid.setColumns(this.columnsViews);
    };

    //# add aggregations into grouping object
    private joinAggAndGrp = (): void =>{
        this.grouping.forEach(item =>{
            item.aggregators = [];
            this.aggregations.forEach(inItem =>{
                for (let prop in inItem.data){
                    let aggregation: any = null;
                    if (inItem.data[prop]){
                        switch (prop){
                            case 'avg':
                                aggregation = new Slick.Data.Aggregators.Avg(inItem.id);
                                break;
                            case 'sum':
                                aggregation = new Slick.Data.Aggregators.Sum(inItem.id);
                                break;
                            case 'min':
                                aggregation = new Slick.Data.Aggregators.Min(inItem.id);
                                break;
                            case 'max':
                                aggregation = new Slick.Data.Aggregators.Max(inItem.id);
                                break;
                        }
                    }
                    if (aggregation){
                        item.aggregators.push(aggregation);
                    }
                }
            })
        })
    };

    //# show aggregations list
    public showAggrList = (): void =>{
        this.showAddAggregation = !this.showAddAggregation;
        this.workingWithToolbar = true;
        // if (this.showAddAggregation){
        //     this.genPopper = true;
        // }

    };

    public showGroupList = (): void =>{
        this.showAddGrouping = !this.showAddGrouping;
        this.workingWithToolbar = true;
        // if (this.showAddGrouping){
        //     this.genPopper = true;
        // }
    }

    //# show aggregation inside aggregation button
    public showSmallAggList = (aggregation: AggregationSelector[]): void =>{
        if (this.selectedAggregation && this.selectedAggregation.id === aggregation[0].id){
            this.selectedAggregation = aggregation[0];
            this.showAggregationSMList = !this.showAggregationSMList;
        } else{
            this.showAggregationSMList = false;
            this.helper.wait(() =>{
                this.selectedAggregation = aggregation[0];
                this.showAggregationSMList = true;
            }, 1)
        }
    };



    public showToolbar = (): void => {
        this.toolbarHidden = false;
    }

    public controlToolbar = (): void => {
        if (!this.fixedToolbar){
            this.fixedToolbar = true;
            this.saveToolbarState();
        } else {
            this.fixedToolbar = false;
            this.toolbarHidden = true;
        }
    }

    public hideToolbar = (e: MouseEvent): void => {
        if (this.helper.hideList(this.headerRef, e, this.renderer)) {
            if (!this.fixedToolbar && !this.workingWithToolbar){
                this.toolbarHidden = true;
                this.dataWorkZone = false;
            }
        }
    }

    /*public showPresetSelect = (): void => {
        this.workingWithToolbar = true;
        this.showPresetSelection = !this.showPresetSelection
    }*/

    public showGridFiltersList = (): void => {
        this.workingWithToolbar = true;
        this.removeSlickFilters = !this.removeSlickFilters
    }

    public showWorkZone = (): void => {
        this.toolbarHidden = false;
        this.dataWorkZone = true;
    }

    public showDataWorkZone = (): void => {
        this.dataWorkZone = !this.dataWorkZone;
        this.toolbarHidden = false;
        // console.log(this.gridFilters, 'this.gridFilters')
    };

    //# save toolbar position to local storage
    private saveToolbarState = () => {
        this.toolbarState = {fixedToolbar: this.fixedToolbar, toolbarHidden: this.toolbarHidden};
        localStorage[this.toolBarName] = JSON.stringify(this.toolbarState);
    }

    //# remove all filters in viewGrid
    public remAllFilters = (): void =>{
        //this.dropdownFilters = [];
        this.grid.clearFilters();
        this.gridFilters.length = 0;
        this.slickFilters.length = 0;
        // this.dataView.refresh();

        this.updateGridView();
    };

    //# remove current filters in viewGrid
    public remCurrentFilter = (id: string): void =>{
        /*let idx: number[] = [];

        this.dropdownFilters.forEach((item, i) =>{
            if (item.column.id === id){
                idx.push(i);
            }
        });
        idx.reverse();
        idx.forEach(item => this.dropdownFilters.splice(item, 1));*/
        this.grid.clearFilters([id]);
        this.remFiltersFromFiltersList([id])
        this.updateGridView();
    };

    //# remove few current filters in viewGrid
    private remFewCurrentFilter = (ids: string[]): void =>{
        /*let idx: number[] = [];

        this.dropdownFilters.forEach((item, i) =>{
            if (item.column.id === id){
                idx.push(i);
            }
        });
        idx.reverse();
        idx.forEach(item => this.dropdownFilters.splice(item, 1));*/
        this.grid.clearFilters(ids);
        this.remFiltersFromFiltersList(ids);
        this.updateGridView();
    };

    private remFiltersFromFiltersList = (ids: string[]): void => {
        this.helper.remFromArrArrComplex(this.gridFilters, 'column', 'id', ids)
        this.helper.remFromArrArr(this.slickFilters, 'columnId', ids)

    }

    private updateGridView = (): void =>{
        // this.updateColors();

        if (this.dataView.getItems().length){
            this.grid.setActiveCell(0, 0);
        }

        //this.onGridClick();
        this.updateColumns = true;
        //this.updatePresetAfterView = true;
        //this.helper.wait(() => this.updateSummary());
    };

    //# clear all trigger function
    public clearAllMain = (command: string): void =>{
        if (!command){
            return;
        }

        switch (command){
            case 'filters':
                this.remAllFilters();
                break;
            case 'aggregations':
                this.remAllAggregations();
                break;
            case 'grouping':
                this.remAllGrouping();
                break;
        }
    };
}




// WEBPACK FOOTER //
// ./src/app/shared/models/stocks-toolbar-helper.ts